export type HotelCityOption = {
  name: string;
  sub: string;
  code: string;
};

export const HOTEL_CITY_OPTIONS: HotelCityOption[] = [
  { name: "تهران", sub: "THR", code: "THR" },
  { name: "مشهد", sub: "MHD", code: "MHD" },
  { name: "کیش", sub: "KIH", code: "KIH" },
  { name: "اصفهان", sub: "IFN", code: "IFN" },
  { name: "شیراز", sub: "SYZ", code: "SYZ" },
  { name: "دبی", sub: "DXB", code: "DXB" },
  { name: "استانبول", sub: "IST", code: "IST" },
  { name: "تبریز", sub: "TBZ", code: "TBZ" },
  { name: "اهواز", sub: "AWZ", code: "AWZ" },
  { name: "رشت", sub: "RAS", code: "RAS" },
  { name: "بندر انزلی", sub: "BAZ", code: "BAZ" },
  { name: "نوشهر", sub: "NSH", code: "NSH" },
  { name: "رامسر", sub: "RZR", code: "RZR" },
  { name: "کرمانشاه", sub: "KSH", code: "KSH" },
  { name: "میبد", sub: "KWH", code: "KWH" },
  { name: "بجنورد", sub: "BJB", code: "BJB" },
  { name: "یزد", sub: "AZD", code: "AZD" },
  { name: "قزوین", sub: "GZW", code: "GZW" },
  { name: "اردبیل", sub: "ADU", code: "ADU" },
  { name: "کرمان", sub: "KER", code: "KER" },
  { name: "بندرعباس", sub: "BND", code: "BND" },
  { name: "ارومیه", sub: "OMH", code: "OMH" },
  { name: "قشم", sub: "GSM", code: "GSM" },
  { name: "سرعین", sub: "SRN", code: "SRN" },
  { name: "لاهیجان", sub: "LHZ", code: "LHZ" },
  { name: "آنتالیا", sub: "YXI", code: "YXI" },
  { name: "کوش آداسی", sub: "KAS", code: "KAS" },
  { name: "کربلا", sub: "HRH", code: "HRH" },
  { name: "بابلسر", sub: "BBL", code: "BBL" },
  { name: "آمل", sub: "AML", code: "AML" },
  { name: "همدان", sub: "HDM", code: "HDM" },
  { name: "کاشان", sub: "KSN", code: "KSN" },
  { name: "ساری", sub: "SRY", code: "SRY" },
  { name: "وان", sub: "VAN", code: "VAN" },
  { name: "آنکارا", sub: "FHC", code: "FHC" },
  { name: "باتومی", sub: "NWM", code: "NWM" },
  { name: "خلخال", sub: "GJJ", code: "GJJ" },
  { name: "گرگان", sub: "GBT", code: "GBT" },
  { name: "سیرجان", sub: "SYJ", code: "SYJ" },
  { name: "لنگرود", sub: "XTB", code: "XTB" },
  { name: "بوشهر", sub: "BUZ", code: "BUZ" },
  { name: "چابهار", sub: "ZBR", code: "ZBR" },
  { name: "کرج", sub: "PYK", code: "PYK" },
  { name: "زنجان", sub: "JWN", code: "JWN" },
  { name: "فردوس", sub: "FRS", code: "FRS" },
  { name: "بانه", sub: "BNH", code: "BNH" },
  { name: "شاهرود", sub: "RUD", code: "RUD" },
  { name: "آستارا", sub: "AST", code: "AST" },
  { name: "مریوان", sub: "SYB", code: "SYB" },
  { name: "شوشتر", sub: "EYS", code: "EYS" },
  { name: "رودسر", sub: "DHR", code: "DHR" },
  { name: "محلات", sub: "ZDF", code: "ZDF" },
  { name: "بهشهر", sub: "BEH", code: "BEH" },
  { name: "دزفول", sub: "DEF", code: "DEF" },
  { name: "فومن", sub: "RNZ", code: "RNZ" },
  { name: "آبادان", sub: "ABD", code: "ABD" },
  { name: "آباده", sub: "JHB", code: "JHB" },
  { name: "آبیدر", sub: "GTF", code: "GTF" },
  { name: "آران و بیدگل", sub: "CVS", code: "CVS" },
  { name: "آزادشهر", sub: "AZS", code: "AZS" },
  { name: "آغاجاری", sub: "AKW", code: "AKW" },
  { name: "ابرکوه", sub: "AOM", code: "AOM" },
  { name: "ابیانه", sub: "JKU", code: "JKU" },
  { name: "اراک", sub: "AJK", code: "AJK" },
  { name: "اردهال", sub: "MMX", code: "MMX" },
  { name: "اردکان", sub: "SRL", code: "SRL" },
  { name: "اسکو", sub: "DCS", code: "DCS" },
  { name: "الموت", sub: "WWM", code: "WWM" },
  { name: "الیگودرز", sub: "VYG", code: "VYG" },
  { name: "املش", sub: "XDS", code: "XDS" },
  { name: "ایرانشهر", sub: "IHR", code: "IHR" },
  { name: "ایلام", sub: "IIL", code: "IIL" },
  { name: "بابل", sub: "BBS", code: "BBS" },
  { name: "بافق", sub: "KSU", code: "KSU" },
  { name: "بانکوک", sub: "BKK", code: "BKK" },
  { name: "باکو", sub: "LAS", code: "LAS" },
  { name: "برازجان", sub: "ITT", code: "ITT" },
  { name: "بروجرد", sub: "BRJ", code: "BRJ" },
  { name: "بروجن", sub: "RYO", code: "RYO" },
  { name: "بسطام", sub: "WZW", code: "WZW" },
  { name: "بم", sub: "BXR", code: "BXR" },
  { name: "بناب", sub: "SCU", code: "SCU" },
  { name: "بندر ترکمن", sub: "BNT", code: "BNT" },
  { name: "بندر لنگه", sub: "BDH", code: "BDH" },
  { name: "بندر گز", sub: "TUW", code: "TUW" },
  { name: "بندرماهشهر", sub: "ZVD", code: "ZVD" },
  { name: "بهبهان", sub: "BJK", code: "BJK" },
  { name: "بیرجند", sub: "XBJ", code: "XBJ" },
  { name: "بیستون", sub: "YVN", code: "YVN" },
  { name: "تالش", sub: "TLS", code: "TLS" },
  { name: "تاکستان", sub: "SYN", code: "SYN" },
  { name: "تربت جام", sub: "NHR", code: "NHR" },
  { name: "تفت", sub: "ZWC", code: "ZWC" },
  { name: "تفرش", sub: "EPL", code: "EPL" },
  { name: "تفلیس", sub: "NVB", code: "NVB" },
  { name: "تنکابن", sub: "TKB", code: "TKB" },
  { name: "جاسک", sub: "JSK", code: "JSK" },
  { name: "جلفا", sub: "KRI", code: "KRI" },
  { name: "جهرم", sub: "JAR", code: "JAR" },
  { name: "جواهرده", sub: "JVH", code: "JVH" },
  { name: "جویبار", sub: "OWY", code: "OWY" },
  { name: "جیرفت", sub: "JYR", code: "JYR" },
  { name: "خان به بین", sub: "HZN", code: "HZN" },
  { name: "خرم آباد", sub: "KHD", code: "KHD" },
  { name: "خرمشهر", sub: "SID", code: "SID" },
  { name: "خوانسار", sub: "FSX", code: "FSX" },
  { name: "خور و بیابانک", sub: "KBK", code: "KBK" },
  { name: "خوی", sub: "KHY", code: "KHY" },
  { name: "داراب", sub: "DWO", code: "DWO" },
  { name: "داران", sub: "HUY", code: "HUY" },
  { name: "دلیجان", sub: "WFN", code: "WFN" },
  { name: "دماوند", sub: "QJB", code: "QJB" },
  { name: "دیزین", sub: "QSQ", code: "QSQ" },
  { name: "رفسنجان", sub: "RJN", code: "RJN" },
  { name: "رودبار", sub: "HUF", code: "HUF" },
  { name: "زابل", sub: "ACZ", code: "ACZ" },
  { name: "زاهدان", sub: "ZAH", code: "ZAH" },
  { name: "زواره", sub: "QMF", code: "QMF" },
  { name: "زیبا کنار", sub: "RHK", code: "RHK" },
  { name: "ساوه", sub: "XSD", code: "XSD" },
  { name: "سبزوار", sub: "AFZ", code: "AFZ" },
  { name: "سراب", sub: "XMV", code: "XMV" },
  { name: "سرخس", sub: "SRK", code: "SRK" },
  { name: "سروستان", sub: "RIE", code: "RIE" },
  { name: "سقز", sub: "VKE", code: "VKE" },
  { name: "سلمان شهر", sub: "SLR", code: "SLR" },
  { name: "سمنان", sub: "SMN", code: "SMN" },
  { name: "سنندج", sub: "SDG", code: "SDG" },
  { name: "سوادکوه", sub: "SVK", code: "SVK" },
  { name: "سپیدان", sub: "SPD", code: "SPD" },
  { name: "سی سخت", sub: "PCV", code: "PCV" },
  { name: "شهرکرد", sub: "CQD", code: "CQD" },
  { name: "شیروان", sub: "GWH", code: "GWH" },
  { name: "صومعه سرا", sub: "NHC", code: "NHC" },
  { name: "طبس", sub: "TCX", code: "TCX" },
  { name: "عباس آباد", sub: "ABS", code: "ABS" },
  { name: "عسلویه", sub: "YEH", code: "YEH" },
  { name: "عسلویه", sub: "PGU", code: "PGU" },
  { name: "علی آبادکتول", sub: "ALK", code: "ALK" },
  { name: "فریدونکنار", sub: "FDK", code: "FDK" },
  { name: "فسا", sub: "CDE", code: "CDE" },
  { name: "فیروزآباد", sub: "YSN", code: "YSN" },
  { name: "قائمشهر", sub: "GSH", code: "GSH" },
  { name: "قروه", sub: "GHR", code: "GHR" },
  { name: "قم", sub: "GHM", code: "GHM" },
  { name: "قمصر", sub: "KJG", code: "KJG" },
  { name: "لار", sub: "VQN", code: "VQN" },
  { name: "لارستان", sub: "LRR", code: "LRR" },
  { name: "لاریجان", sub: "LRJ", code: "LRJ" },
  { name: "لالجین", sub: "YUV", code: "YUV" },
  { name: "لامرد", sub: "LFM", code: "LFM" },
  { name: "لاویج", sub: "LVJ", code: "LVJ" },
  { name: "لرستان", sub: "LGP", code: "LGP" },
  { name: "ماسال", sub: "MSL", code: "MSL" },
  { name: "ماهان", sub: "GUI", code: "GUI" },
  { name: "ماهشهر", sub: "MRX", code: "MRX" },
  { name: "ماکو", sub: "MAC", code: "MAC" },
  { name: "ماکو", sub: "IMQ", code: "IMQ" },
  { name: "مبارکه", sub: "DYY", code: "DYY" },
  { name: "محمودآباد", sub: "MAB", code: "MAB" },
  { name: "مراغه", sub: "ACP", code: "ACP" },
  { name: "مرزن آباد", sub: "MWR", code: "MWR" },
  { name: "مرند", sub: "KLJ", code: "KLJ" },
  { name: "مرودشت", sub: "IEC", code: "IEC" },
  { name: "مشگین شهر", sub: "OFV", code: "OFV" },
  { name: "ملایر", sub: "OVM", code: "OVM" },
  { name: "مهاباد", sub: "KXW", code: "KXW" },
  { name: "مهدی شهر", sub: "WUB", code: "WUB" },
  { name: "مهریز", sub: "NLJ", code: "NLJ" },
  { name: "میناب", sub: "UTH", code: "UTH" },
  { name: "مینودشت", sub: "MNS", code: "MNS" },
  { name: "نائین", sub: "UUM", code: "UUM" },
  { name: "نهبندان", sub: "GPG", code: "GPG" },
  { name: "نور", sub: "NOR", code: "NOR" },
  { name: "نکا", sub: "NKA", code: "NKA" },
  { name: "نیاسر", sub: "IJF", code: "IJF" },
  { name: "نیشابور", sub: "NSB", code: "NSB" },
  { name: "پارس آباد", sub: "PFQ", code: "PFQ" },
  { name: "پاوه", sub: "KWS", code: "KWS" },
  { name: "پیرانشهر", sub: "FRI", code: "FRI" },
  { name: "چابکسر", sub: "CBS", code: "CBS" },
  { name: "چالوس", sub: "CLS", code: "CLS" },
  { name: "چناران", sub: "OAZ", code: "OAZ" },
  { name: "کردکوی", sub: "XPC", code: "XPC" },
  { name: "کلاردشت", sub: "KLD", code: "KLD" },
  { name: "کلاله", sub: "KLM", code: "KLM" },
  { name: "کلاچای", sub: "BXM", code: "BXM" },
  { name: "کلیبر", sub: "TSH", code: "TSH" },
  { name: "کوهرنگ", sub: "KIV", code: "KIV" },
  { name: "کوهپایه", sub: "KPO", code: "KPO" },
  { name: "گالیکش", sub: "GGB", code: "GGB" },
  { name: "گرمسار", sub: "GTB", code: "GTB" },
  { name: "گلپایگان", sub: "QIE", code: "QIE" },
  { name: "گنبدکاووس", sub: "PMP", code: "PMP" },
  { name: "گچساران", sub: "GCH", code: "GCH" },
  { name: "گچسر", sub: "VPC", code: "VPC" },
  { name: "یاسوج", sub: "YES", code: "YES" },
  { name: "ایروان", sub: "IRV", code: "IRV" },
  { name: "ازمیر", sub: "AZM", code: "AZM" },
  { name: "بندر گناوه", sub: "BGH", code: "BGH" },
  { name: "اورامان", sub: "ORM", code: "ORM" },
  { name: "رامیان", sub: "TXB", code: "TXB" },
  { name: "قلعه گنج", sub: "IQY", code: "IQY" },
  { name: "بیجار", sub: "YAC", code: "YAC" },
  { name: "شاهین شهر", sub: "WFM", code: "WFM" },
  { name: "اندیمشک", sub: "QEM", code: "QEM" },
  { name: "اسالم", sub: "ZLZ", code: "ZLZ" },
  { name: "دورود", sub: "REK", code: "REK" },
  { name: "اقلید", sub: "XGY", code: "XGY" },
  { name: "طالقان", sub: "YQN", code: "YQN" },
  { name: "آبگرم", sub: "MZI", code: "MZI" },
  { name: "نطنز", sub: "UYX", code: "UYX" },
  { name: "ورامین", sub: "TVF", code: "TVF" },
  { name: "سلماس", sub: "VHI", code: "VHI" },
  { name: "بادرود", sub: "LBL", code: "LBL" },
  { name: "نشتارود", sub: "XMR", code: "XMR" },
  { name: "بندرکنگان", sub: "RSN", code: "RSN" },
  { name: "جوانرود", sub: "REJ", code: "REJ" },
  { name: "شهرضا", sub: "DLF", code: "DLF" },
  { name: "جزیره ابوموسی", sub: "NSY", code: "NSY" },
  { name: "خانه", sub: "DOB", code: "DOB" },
  { name: "قونیه", sub: "FAV", code: "FAV" },
  { name: "کیاشهر", sub: "NPB", code: "NPB" },
  { name: "زیرآب", sub: "FQX", code: "FQX" },
  { name: "رضوانشهر", sub: "WNJ", code: "WNJ" },
  { name: "استهبان", sub: "ZBU", code: "ZBU" },
  { name: "ماسوله", sub: "YHP", code: "YHP" },
  { name: "گلمکان", sub: "MGX", code: "MGX" },
  { name: "جزیره هرمز", sub: "VSS", code: "VSS" },
  { name: "نجف", sub: "BOY", code: "BOY" },
  { name: "خمین", sub: "EBV", code: "EBV" },
  { name: "پاتایا", sub: "OEQ", code: "OEQ" },
  { name: "شهداد", sub: "TZQ", code: "TZQ" },
  { name: "خارک", sub: "IAR", code: "IAR" },
  { name: "دامغان", sub: "AWT", code: "AWT" },
  { name: "هنگام", sub: "TGW", code: "TGW" },
  { name: "بافت", sub: "YSC", code: "YSC" },
  { name: "آستانه اشرفیه", sub: "UGG", code: "UGG" },
  { name: "میاندوآب", sub: "MVE", code: "MVE" },
  { name: "کابل", sub: "KBL", code: "KBL" },
  { name: "پوکت", sub: "COL", code: "COL" },
  { name: "آغری", sub: "AJI", code: "AJI" },
  { name: "آیدین", sub: "CII", code: "CII" },
  { name: "توکات", sub: "TJK", code: "TJK" },
  { name: "ارجان", sub: "ECN", code: "ECN" },
  { name: "تفلیس", sub: "TBS", code: "TBS" },
];

export function getHotelCityNameByCode(cityCode?: string | null) {
  if (!cityCode) return undefined;

  const normalizedCode = cityCode.toUpperCase();

  return HOTEL_CITY_OPTIONS.find((city) => city.code === normalizedCode)?.name;
}
